import { BITCOIN_MIN_DEPOSIT } from "#/shared/constants"
import { BridgeableTokens } from "#/shared/types"
import { floatToBigInt } from "#/shared/utils"

import useERC20Tokens from "./useERC20Tokens"

export default function useMinBridgeAmount(token: BridgeableTokens) {
  const { data, ...rest } = useERC20Tokens()

  const ALL_BRIDGEABLE_TOKENS = {
    ...data,
    BTC: floatToBigInt(BITCOIN_MIN_DEPOSIT, 8),
  }

  return {
    ...rest,
    data: ALL_BRIDGEABLE_TOKENS[token],
  }
}
